module.exports = __webpack_public_path__ + "img/4.068a1be6.jpg";